const DEFAULT_FORM_NAME = "onboarding-tier1";
const MIN_LEAD_CAPTURE_SLUG_LENGTH = 3;
const MAX_LEAD_CAPTURE_SLUG_LENGTH = 60;

const RESERVED_LEAD_CAPTURE_SLUGS = new Set([
  "onboarding-tier1",
  "onboarding-lite",
  "onboarding-scan",
  "onboarding-scan-all-poses",
  "onboarding-advertise",
  "onboarding-chatbot",
  "onboarding-tier1-chatbot",
  "onboarding-single-procedure",
  "assets",
  "api",
  "admin",
  "health",
]);

const getFormBaseUrl = () =>
  process.env.EXPO_PUBLIC_ENV === "production"
    ? "https://form.clinicos.ai"
    : "https://form-staging.clinicos.ai";

export const buildLeadCaptureShareUrl = (params: {
  formUrl?: string | null;
  clinicSdkKey?: string | null;
  slug?: string | null;
}) => {
  const { formUrl, clinicSdkKey, slug } = params;
  if (formUrl?.trim()) {
    return formUrl.trim();
  }

  const resolvedSlug = slug?.trim();
  if (resolvedSlug) {
    return `${getFormBaseUrl()}/${encodeURIComponent(resolvedSlug)}`;
  }

  const resolvedClinicSdkKey = clinicSdkKey?.trim();
  if (!resolvedClinicSdkKey) return "";

  const shareParams = new URLSearchParams();
  shareParams.set("clinicSdkKey", resolvedClinicSdkKey);

  return `${getFormBaseUrl()}/${DEFAULT_FORM_NAME}?${shareParams.toString()}`;
};

export const getLeadCaptureFormBaseUrl = getFormBaseUrl;

export const normalizeLeadCaptureSlug = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const getLeadCaptureSlugValidationError = (value: string) => {
  const slug = normalizeLeadCaptureSlug(value);

  if (!slug) return "Enter a custom slug.";
  if (slug.length < MIN_LEAD_CAPTURE_SLUG_LENGTH) {
    return `Use at least ${MIN_LEAD_CAPTURE_SLUG_LENGTH} characters.`;
  }
  if (slug.length > MAX_LEAD_CAPTURE_SLUG_LENGTH) {
    return `Use ${MAX_LEAD_CAPTURE_SLUG_LENGTH} characters or fewer.`;
  }
  if (RESERVED_LEAD_CAPTURE_SLUGS.has(slug)) {
    return "This slug is reserved. Try a clinic-specific slug.";
  }

  return "";
};
